var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCommentBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.184,
    height: 26.407,
    viewBox: "0 0 30.184 26.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon_comment_none",
    d: "M8.426 42.374a1.886 1.886 0 1 0 1.886 1.886 1.884 1.884 0 0 0-1.886-1.886zm6.6 0a1.886 1.886 0 1 0 1.886 1.886 1.884 1.884 0 0 0-1.885-1.886zm6.6 0a1.886 1.886 0 1 0 1.886 1.886 1.884 1.884 0 0 0-1.883-1.886zM15.027 32C6.693 32-.062 37.488-.062 44.261a10.836 10.836 0 0 0 3.118 7.445A14.958 14.958 0 0 1 .321 56.02a1.415 1.415 0 0 0 1.032 2.387 14.3 14.3 0 0 0 8.2-2.729 18.2 18.2 0 0 0 5.476.843c8.335 0 15.09-5.488 15.09-12.261S23.362 32 15.027 32z",
    transform: "translate(.066 -32)",
    style: {
      fill: "#3a9cfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon_comment_none",
    d: "M8.426 42.374a1.886 1.886 0 1 0 1.886 1.886 1.884 1.884 0 0 0-1.886-1.886zm6.6 0a1.886 1.886 0 1 0 1.886 1.886 1.884 1.884 0 0 0-1.885-1.886zm6.6 0a1.886 1.886 0 1 0 1.886 1.886 1.884 1.884 0 0 0-1.883-1.886z",
    transform: "translate(.066 -32)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentBlue);
export default __webpack_public_path__ + "static/media/icon-comment-blue.0222e47e97035a13e659bf2c35ec5eae.svg";
export { ForwardRef as ReactComponent };